export default {
  styleOverrides: {
    root: {
      outline: 'none',
    },
  },
};
